var render = function () {
  var _class, _class2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-group",
    class: (_class = {
      'row ': _vm.formGroupRow,
      'label-requires': _vm.required || _vm.rules.required
    }, _class[("" + (_vm.formGroupClass))] = _vm.formGroupClass, _class)
  }, [_vm.type !== 'divider' ? _c('label', {
    staticClass: "d-block form-label",
    class: (_class2 = {}, _class2[("" + (_vm.labelClass))] = _vm.labelClass, _class2),
    staticStyle: {
      "margin-bottom": "6px"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.label) + _vm.labelAfterFix || ""))]) : _vm._e(), _c('validation-provider', {
    attrs: {
      "rules": _vm.rules,
      "name": _vm.$t(_vm.label)
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors;
        return [_vm.type === 'date' ? _c('WidgetDateTime', {
          attrs: {
            "clearable": !_vm.noClearable,
            "timePicker": _vm.timePicker,
            "max-date": _vm.maxDate,
            "disabled": _vm.disabled,
            "isRange": _vm.isRange,
            "placeholder": _vm.$t(_vm.placeholder) || _vm.$t(_vm.label)
          },
          model: {
            value: _vm.currentValue,
            callback: function ($$v) {
              _vm.currentValue = $$v;
            },
            expression: "currentValue"
          }
        }) : _vm._e(), _vm.type === 'select' ? _c('WidgetSelect', {
          attrs: {
            "disabledItemAfterFix": _vm.disabledItemAfterFix,
            "disabledItem": _vm.disabledItem,
            "defaultValue": _vm.defaultValue,
            "customOptions": _vm.customOptions,
            "errors": errors,
            "placeholder": _vm.placeholder || _vm.label,
            "dataSource": _vm.dataSource,
            "multiple": _vm.multiple,
            "noClearable": _vm.noClearable,
            "dataSourceParams": _vm.dataSourceParams,
            "label": _vm.labelOption,
            "disabled": _vm.disabled,
            "customReduce": _vm.customReduce
          },
          model: {
            value: _vm.currentValue,
            callback: function ($$v) {
              _vm.currentValue = $$v;
            },
            expression: "currentValue"
          }
        }) : _vm._e(), _vm.type === 'divider' ? _c('WidgetDivider', {
          attrs: {
            "variant": _vm.variant,
            "label": _vm.label
          }
        }) : _vm._e(), _vm.type === 'string' ? _c('WidgetString', {
          attrs: {
            "disabled": _vm.disabled,
            "rows": _vm.rows,
            "variant": _vm.variant,
            "errors": errors,
            "placeholder": _vm.placeholder || _vm.label
          },
          model: {
            value: _vm.currentValue,
            callback: function ($$v) {
              _vm.currentValue = $$v;
            },
            expression: "currentValue"
          }
        }) : _vm._e(), _vm.type === 'cleave' ? _c('WidgetCleave', {
          attrs: {
            "cleaveOptions": _vm.cleaveOptions,
            "defaultValue": _vm.defaultValue,
            "errors": errors,
            "type": _vm.cleaveType,
            "disabled": _vm.disabled,
            "placeholder": _vm.placeholder || _vm.label
          },
          model: {
            value: _vm.currentValue,
            callback: function ($$v) {
              _vm.currentValue = $$v;
            },
            expression: "currentValue"
          }
        }) : _vm._e(), _vm.currentValue && _vm.showVnPriceText ? _c('div', {
          staticClass: "text-right font-weight-bold font-italic text-primary",
          staticStyle: {
            "font-size": "10px",
            "margin-top": "6px"
          }
        }, [_vm._v(" " + _vm._s(_vm.numberToVnText(_vm.currentValue)) + " ")]) : _vm._e(), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }